import React from 'react';

const LogOutIcon = () => (
  <svg width="52px" height="52px" viewBox="0 0 28 28" version="1.1">
    <g
      id="Global-Nav"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Elements"
        transform="translate(-1138.000000, -93.000000)"
        fill="#006FE4"
      >
        <g id="Nav/Default" transform="translate(188.000000, 67.000000)">
          <g
            id="Btn/Nav/Menu/Logout"
            transform="translate(936.000000, 12.000000)"
          >
            <g id="Group" transform="translate(14.000000, 14.000000)">
              <path
                d="M15.9632184,1.30290741 L15.9632184,26.6970926 C15.9632184,27.5443092 15.1499072,28.1659563
                14.3103128,27.9604761 L1.00763077,24.7048113 C0.415439265,24.5598799 0,24.0389955 0,23.4414278
                L0,4.55857217 C0,3.96100448 0.415439265,3.44012012 1.00763077,3.29518867 L14.3103128,0.039523905
                C15.1499072,-0.165956311 15.9632184,0.455690775 15.9632184,1.30290741 Z M10.3095785,11.7210347
                C9.39122002,11.7210347 8.64674332,12.44984 8.64674332,13.348867 C8.64674332,14.2478941
                9.39122002,14.9766994 10.3095785,14.9766994 C11.2279371,14.9766994 11.9724138,14.2478941
                11.9724138,13.348867 C11.9724138,12.44984 11.2279371,11.7210347 10.3095785,11.7210347 Z"
                id="Combined-Shape"
              />
              <path
                d="M23.7785441,19.3103448 C24.4213951,19.3103448 24.9425287,19.7426216 24.9425287,20.2758621
                L24.9425287,20.2758621 L24.9425287,24.1379311 C24.9425287,24.6711715 24.4213951,25.1034483
                23.7785441,25.1034483 L23.7785441,25.1034483 L19.1226054,25.1034483 C18.4797544,25.1034483
                17.9586207,24.6711715 17.9586207,24.1379311 C17.9586207,23.6046906 18.4797544,23.1724138
                19.1226054,23.1724138 L19.1226054,23.1724138 L22.6145594,23.1724138 L22.6145594,20.2758621
                C22.6145594,19.7426216 23.1356931,19.3103448 23.7785441,19.3103448 Z"
                id="Combined-Shape-Copy-2-path"
              />
              <path
                d="M21.0727656,10.8792233 C21.4623921,10.5345118 22.0941015,10.5345118 22.4837281,10.8792233
                C22.8733546,11.2239347 22.8733546,11.7828225 22.4837281,12.127534 L22.4837281,12.127534
                L21.4122551,13.0754905 L26.937931,13.0754905 C27.4889462,13.0754905 27.9356322,13.4706838
                27.9356322,13.9581795 C27.9356322,14.4456751 27.4889462,14.8408684 26.937931,14.8408684
                L26.937931,14.8408684 L21.3177159,14.8408684 L22.4837281,15.872466 C22.8733546,16.2171775
                22.8733546,16.7760652 22.4837281,17.1207768 C22.0941015,17.4654882 21.4623921,17.4654882
                21.0727656,17.1207768 L21.0727656,17.1207768 L18.2508406,14.6241553 C17.8612141,14.2794439
                17.8612141,13.7205562 18.2508406,13.3758446 L18.2508406,13.3758446 L21.0727656,10.8792233 Z"
                id="Combined-Shape-Copy-2-path"
                transform="translate(22.947126, 14.000000) rotate(-180.000000) translate(-22.947126, -14.000000) "
              />
              <path
                d="M23.7785441,2.89655172 C24.4213951,2.89655172 24.9425287,3.32882852 24.9425287,3.86206896
                L24.9425287,3.86206896 L24.9425287,7.72413792 C24.9425287,8.25737834 24.4213951,8.68965517
                23.7785441,8.68965517 C23.1356931,8.68965517 22.6145594,8.25737834 22.6145594,7.72413792
                L22.6145594,7.72413792 L22.6145594,4.8275862 L19.1226054,4.8275862 C18.4797544,4.8275862
                17.9586207,4.39530941 17.9586207,3.86206896 C17.9586207,3.32882852 18.4797544,2.89655172
                19.1226054,2.89655172 L19.1226054,2.89655172 L23.7785441,2.89655172 Z"
                id="Combined-Shape-Copy-2-path"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default LogOutIcon;
